import React from "react";
import { Application as ApplicationEnum } from "../../../graphql/generated";
import { ReactComponent as ZenlistSvg } from './zenlist.svg';
import { ReactComponent as RdcSvg } from './rdc.svg';

export const Application: React.FC<{ application?: ApplicationEnum }> = ({ application }) => {
    if (!application) {
        return <span>Unknown</span>;
    }

    switch (application) {
        case ApplicationEnum.Zenlist:
            return <span><ApplicationIcon application={application} /> Zenlist</span>;
        case ApplicationEnum.RealtorPlus:
            return <span><ApplicationIcon application={application} /> Realtor+</span>;
    }
};

export const ApplicationIcon: React.FC<{ application?: ApplicationEnum }> = ({ application }) => {
    if (!application) {
        return <span>Unknown</span>;
    }

    switch (application) {
        case ApplicationEnum.Zenlist:
            return <ZenlistSvg width="1em" height="1em" style={{ display: "inline" }} />;
        case ApplicationEnum.RealtorPlus:
            return <RdcSvg width="1em" height="1em" style={{ display: "inline" }} />;
    }
};
